@file:OptIn(InternalResourceApi::class)

package fr.frux.feature.harvestcreate.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/fr.frux.feature.harvestcreate.resources/"

@delegate:ResourceContentHash(1_707_039_062)
internal val Res.string.harvestcreate_close: StringResource by lazy {
      StringResource("string:harvestcreate_close", "harvestcreate_close", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 35),
      ))
    }

@delegate:ResourceContentHash(-1_065_163_855)
internal val Res.string.harvestcreate_date_picker_cancel: StringResource by lazy {
      StringResource("string:harvestcreate_date_picker_cancel", "harvestcreate_date_picker_cancel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 46, 52),
      ))
    }

@delegate:ResourceContentHash(1_976_862_229)
internal val Res.string.harvestcreate_date_picker_confirm: StringResource by lazy {
      StringResource("string:harvestcreate_date_picker_confirm", "harvestcreate_date_picker_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 99, 53),
      ))
    }

@delegate:ResourceContentHash(1_211_531_840)
internal val Res.string.harvestcreate_description_label: StringResource by lazy {
      StringResource("string:harvestcreate_description_label", "harvestcreate_description_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 153, 87),
      ))
    }

@delegate:ResourceContentHash(813_471_685)
internal val Res.string.harvestcreate_description_placeholder: StringResource by lazy {
      StringResource("string:harvestcreate_description_placeholder", "harvestcreate_description_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 241, 109),
      ))
    }

@delegate:ResourceContentHash(340_307_973)
internal val Res.string.harvestcreate_error_past_slot: StringResource by lazy {
      StringResource("string:harvestcreate_error_past_slot", "harvestcreate_error_past_slot", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 351, 113),
      ))
    }

@delegate:ResourceContentHash(-388_100_573)
internal val Res.string.harvestcreate_foraging_rule_notice: StringResource by lazy {
      StringResource("string:harvestcreate_foraging_rule_notice", "harvestcreate_foraging_rule_notice", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 465, 234),
      ))
    }

@delegate:ResourceContentHash(-563_175_373)
internal val Res.string.harvestcreate_hour_label: StringResource by lazy {
      StringResource("string:harvestcreate_hour_label", "harvestcreate_hour_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 700, 40),
      ))
    }

@delegate:ResourceContentHash(-1_444_220_853)
internal val Res.string.harvestcreate_other_date: StringResource by lazy {
      StringResource("string:harvestcreate_other_date", "harvestcreate_other_date", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 741, 48),
      ))
    }

@delegate:ResourceContentHash(-1_093_466_325)
internal val Res.string.harvestcreate_participants_count: StringResource by lazy {
      StringResource("string:harvestcreate_participants_count", "harvestcreate_participants_count", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 790, 60),
      ))
    }

@delegate:ResourceContentHash(-1_835_891_499)
internal val Res.string.harvestcreate_participants_decrement: StringResource by lazy {
      StringResource("string:harvestcreate_participants_decrement", "harvestcreate_participants_decrement", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 851, 72),
      ))
    }

@delegate:ResourceContentHash(528_383_573)
internal val Res.string.harvestcreate_participants_increment: StringResource by lazy {
      StringResource("string:harvestcreate_participants_increment", "harvestcreate_participants_increment", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 924, 68),
      ))
    }

@delegate:ResourceContentHash(-691_049_677)
internal val Res.string.harvestcreate_participants_unlimited: StringResource by lazy {
      StringResource("string:harvestcreate_participants_unlimited", "harvestcreate_participants_unlimited", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 993, 60),
      ))
    }

@delegate:ResourceContentHash(929_293_643)
internal val Res.string.harvestcreate_section_participants: StringResource by lazy {
      StringResource("string:harvestcreate_section_participants", "harvestcreate_section_participants", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1054, 74),
      ))
    }

@delegate:ResourceContentHash(-480_837_891)
internal val Res.string.harvestcreate_section_when: StringResource by lazy {
      StringResource("string:harvestcreate_section_when", "harvestcreate_section_when", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1129, 46),
      ))
    }

@delegate:ResourceContentHash(918_834_877)
internal val Res.string.harvestcreate_site_hint_baskets: StringResource by lazy {
      StringResource("string:harvestcreate_site_hint_baskets", "harvestcreate_site_hint_baskets", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1176, 87),
      ))
    }

@delegate:ResourceContentHash(-1_347_377_507)
internal val Res.string.harvestcreate_site_hint_gate: StringResource by lazy {
      StringResource("string:harvestcreate_site_hint_gate", "harvestcreate_site_hint_gate", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1264, 60),
      ))
    }

@delegate:ResourceContentHash(-1_163_906_962)
internal val Res.string.harvestcreate_site_hint_path: StringResource by lazy {
      StringResource("string:harvestcreate_site_hint_path", "harvestcreate_site_hint_path", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1325, 64),
      ))
    }

@delegate:ResourceContentHash(119_203_518)
internal val Res.string.harvestcreate_site_hints_title: StringResource by lazy {
      StringResource("string:harvestcreate_site_hints_title", "harvestcreate_site_hints_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1390, 86),
      ))
    }

@delegate:ResourceContentHash(961_198_819)
internal val Res.string.harvestcreate_site_hosted_hint: StringResource by lazy {
      StringResource("string:harvestcreate_site_hosted_hint", "harvestcreate_site_hosted_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1477, 158),
      ))
    }

@delegate:ResourceContentHash(-1_287_910_342)
internal val Res.string.harvestcreate_site_hosted_title: StringResource by lazy {
      StringResource("string:harvestcreate_site_hosted_title", "harvestcreate_site_hosted_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1636, 71),
      ))
    }

@delegate:ResourceContentHash(-1_903_440_283)
internal val Res.string.harvestcreate_site_loading: StringResource by lazy {
      StringResource("string:harvestcreate_site_loading", "harvestcreate_site_loading", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1708, 62),
      ))
    }

@delegate:ResourceContentHash(-565_044_003)
internal val Res.string.harvestcreate_site_one_date_hint: StringResource by lazy {
      StringResource("string:harvestcreate_site_one_date_hint", "harvestcreate_site_one_date_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1771, 152),
      ))
    }

@delegate:ResourceContentHash(-1_164_105_189)
internal val Res.string.harvestcreate_site_plantings_count: StringResource by lazy {
      StringResource("string:harvestcreate_site_plantings_count", "harvestcreate_site_plantings_count", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1924, 66),
      ))
    }

@delegate:ResourceContentHash(320_898_767)
internal val Res.string.harvestcreate_site_reminder_label: StringResource by lazy {
      StringResource("string:harvestcreate_site_reminder_label", "harvestcreate_site_reminder_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1991, 57),
      ))
    }

@delegate:ResourceContentHash(-1_654_442_654)
internal val Res.string.harvestcreate_site_rule_ask: StringResource by lazy {
      StringResource("string:harvestcreate_site_rule_ask", "harvestcreate_site_rule_ask", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2049, 55),
      ))
    }

@delegate:ResourceContentHash(1_173_174_668)
internal val Res.string.harvestcreate_site_rule_open: StringResource by lazy {
      StringResource("string:harvestcreate_site_rule_open", "harvestcreate_site_rule_open", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2105, 60),
      ))
    }

@delegate:ResourceContentHash(-484_137_591)
internal val Res.string.harvestcreate_site_rule_private: StringResource by lazy {
      StringResource("string:harvestcreate_site_rule_private", "harvestcreate_site_rule_private", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2166, 47),
      ))
    }

@delegate:ResourceContentHash(439_552_605)
internal val Res.string.harvestcreate_site_unavailable: StringResource by lazy {
      StringResource("string:harvestcreate_site_unavailable", "harvestcreate_site_unavailable", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2214, 82),
      ))
    }

@delegate:ResourceContentHash(-1_114_838_353)
internal val Res.string.harvestcreate_submit: StringResource by lazy {
      StringResource("string:harvestcreate_submit", "harvestcreate_submit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2297, 56),
      ))
    }

@delegate:ResourceContentHash(-1_624_967_384)
internal val Res.string.harvestcreate_title: StringResource by lazy {
      StringResource("string:harvestcreate_title", "harvestcreate_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2354, 55),
      ))
    }

@delegate:ResourceContentHash(-250_068_880)
internal val Res.string.harvestcreate_tree_loading: StringResource by lazy {
      StringResource("string:harvestcreate_tree_loading", "harvestcreate_tree_loading", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2410, 66),
      ))
    }

@delegate:ResourceContentHash(-1_301_858_267)
internal val Res.string.harvestcreate_tree_unavailable: StringResource by lazy {
      StringResource("string:harvestcreate_tree_unavailable", "harvestcreate_tree_unavailable", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2477, 82),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("harvestcreate_close", Res.string.harvestcreate_close)
  map.put("harvestcreate_date_picker_cancel", Res.string.harvestcreate_date_picker_cancel)
  map.put("harvestcreate_date_picker_confirm", Res.string.harvestcreate_date_picker_confirm)
  map.put("harvestcreate_description_label", Res.string.harvestcreate_description_label)
  map.put("harvestcreate_description_placeholder", Res.string.harvestcreate_description_placeholder)
  map.put("harvestcreate_error_past_slot", Res.string.harvestcreate_error_past_slot)
  map.put("harvestcreate_foraging_rule_notice", Res.string.harvestcreate_foraging_rule_notice)
  map.put("harvestcreate_hour_label", Res.string.harvestcreate_hour_label)
  map.put("harvestcreate_other_date", Res.string.harvestcreate_other_date)
  map.put("harvestcreate_participants_count", Res.string.harvestcreate_participants_count)
  map.put("harvestcreate_participants_decrement", Res.string.harvestcreate_participants_decrement)
  map.put("harvestcreate_participants_increment", Res.string.harvestcreate_participants_increment)
  map.put("harvestcreate_participants_unlimited", Res.string.harvestcreate_participants_unlimited)
  map.put("harvestcreate_section_participants", Res.string.harvestcreate_section_participants)
  map.put("harvestcreate_section_when", Res.string.harvestcreate_section_when)
  map.put("harvestcreate_site_hint_baskets", Res.string.harvestcreate_site_hint_baskets)
  map.put("harvestcreate_site_hint_gate", Res.string.harvestcreate_site_hint_gate)
  map.put("harvestcreate_site_hint_path", Res.string.harvestcreate_site_hint_path)
  map.put("harvestcreate_site_hints_title", Res.string.harvestcreate_site_hints_title)
  map.put("harvestcreate_site_hosted_hint", Res.string.harvestcreate_site_hosted_hint)
  map.put("harvestcreate_site_hosted_title", Res.string.harvestcreate_site_hosted_title)
  map.put("harvestcreate_site_loading", Res.string.harvestcreate_site_loading)
  map.put("harvestcreate_site_one_date_hint", Res.string.harvestcreate_site_one_date_hint)
  map.put("harvestcreate_site_plantings_count", Res.string.harvestcreate_site_plantings_count)
  map.put("harvestcreate_site_reminder_label", Res.string.harvestcreate_site_reminder_label)
  map.put("harvestcreate_site_rule_ask", Res.string.harvestcreate_site_rule_ask)
  map.put("harvestcreate_site_rule_open", Res.string.harvestcreate_site_rule_open)
  map.put("harvestcreate_site_rule_private", Res.string.harvestcreate_site_rule_private)
  map.put("harvestcreate_site_unavailable", Res.string.harvestcreate_site_unavailable)
  map.put("harvestcreate_submit", Res.string.harvestcreate_submit)
  map.put("harvestcreate_title", Res.string.harvestcreate_title)
  map.put("harvestcreate_tree_loading", Res.string.harvestcreate_tree_loading)
  map.put("harvestcreate_tree_unavailable", Res.string.harvestcreate_tree_unavailable)
}
